// Static header with trust signals for the Numerology page.

type Lang = "en" | "hi";

interface HeaderCopy {
  kicker: string;
  h1: string;
  sub: string;
  accurate: string;
  instant: string;
  free: string;
}

const HEADER_COPY: Record<Lang, HeaderCopy> = {
  en: {
    kicker: "Ank Jyotish",
    h1: "Free Numerology Calculator",
    sub: "Enter your name and date of birth to find your Mulank, Bhagyank, and Name Number with ruling planet and personality traits — 100% free.",
    accurate: "Vedic ank ganana",
    instant: "Instant Results",
    free: "100% Free",
  },
  hi: {
    kicker: "अंक ज्योतिष",
    h1: "मुफ़्त अंक ज्योतिष कैलकुलेटर",
    sub: "अपना नाम और जन्म तिथि दर्ज करें — मूलांक, भाग्यांक और नाम अंक के साथ शासक ग्रह और व्यक्तित्व विशेषताएँ देखें — 100% निःशुल्क।",
    accurate: "वैदिक अंक गणना",
    instant: "तुरंत परिणाम",
    free: "100% निःशुल्क",
  },
};

export function NumerologyHeader({ language }: { language: Lang }) {
  const copy = HEADER_COPY[language];
  return (
    <div className="text-center mb-10">
      <p
        className="text-[11px] font-semibold uppercase tracking-[0.25em] mb-3"
        style={{ color: "var(--ish-accent)" }}
      >
        {copy.kicker}
      </p>
      <h1
        className="text-[28px] sm:text-[36px] font-bold leading-tight"
        style={{
          fontFamily: "var(--font-pt-serif), PT Serif, Georgia, serif",
          color: "var(--ish-dark)",
        }}
      >
        {copy.h1}
      </h1>
      <p
        className="mt-3 text-[15px] leading-relaxed max-w-md mx-auto"
        style={{ color: "var(--ish-text-muted)" }}
      >
        {copy.sub}
      </p>

      {/* Trust signals */}
      <div
        className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-medium"
        style={{ color: "var(--ish-text-faint)" }}
      >
        <span className="flex items-center gap-1.5">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          {copy.accurate}
        </span>
        <span className="flex items-center gap-1.5">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
          {copy.instant}
        </span>
        <span className="flex items-center gap-1.5">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          {copy.free}
        </span>
      </div>
    </div>
  );
}
